module.exports = __webpack_public_path__ + "static/bee-astronomy-11e2e4460df0599c7ce380bbb42a9395.jpg";